module.exports = __webpack_public_path__ + "static/media/interdict_counter.9a06ef06.jpg";